import bafangLogo from "../../../resources/images/gear-brands/bafang.svg";
import campagnoloLogo from "../../../resources/images/gear-brands/campagnolo.svg";
import envioloLogo from "../../../resources/images/gear-brands/enviolo.svg";
import hopeLogo from "../../../resources/images/gear-brands/hope.png";
import microshiftLogo from "../../../resources/images/gear-brands/microshift.svg";
import pinionLogo from "../../../resources/images/gear-brands/pinion.png";
import rohloffLogo from "../../../resources/images/gear-brands/rohloff.png";
import shimanoLogo from "../../../resources/images/gear-brands/shimano.svg";
import sramLogo from "../../../resources/images/gear-brands/sram.png";
import sturmeyArcherLogo from "../../../resources/images/gear-brands/sturmey-archer.svg";
import sunraceLogo from "../../../resources/images/gear-brands/sunrace.svg";
import tektroLogo from "../../../resources/images/gear-brands/tektro.png";
import threeByThreeLogo from "../../../resources/images/gear-brands/three-by-three.svg";
import trpLogo from "../../../resources/images/gear-brands/trp.svg";

export const gearBrandLogos = {
  SHIMANO: shimanoLogo,
  SRAM: sramLogo,
  CAMPAGNOLO: campagnoloLogo,
  ROHLOFF: rohloffLogo,
  PINION: pinionLogo,
  BAFANG: bafangLogo,
  ENVIOLO: envioloLogo,
  MICROSHIFT: microshiftLogo,
  SUNRACE: sunraceLogo,
  STURMEY_ARCHER: sturmeyArcherLogo,
  TRP: trpLogo,
  TEKTRO: tektroLogo,
  THREE_BY_THREE: threeByThreeLogo,
  HOPE: hopeLogo
} as const;

type GearBrandLogoKey = keyof typeof gearBrandLogos;

export const getGearBrandLogo = (brandKey: string): string => {
  return gearBrandLogos[brandKey as GearBrandLogoKey] ?? "";
};
